import React from 'react';
import './Projects.css';

const Projects = () => {
  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Featured Project</h2>
        <div className="project-case-study">
          <div className="project-header">
            <h3 className="project-name">MJISMAT Platform</h3>
          </div>
          <div className="project-content">
            <div className="project-section">
              <h4 className="project-section-title">Problem</h4>
              <p className="project-section-text">
                Fragmented municipal service delivery.
              </p>
            </div>
            <div className="project-section">
              <h4 className="project-section-title">Solution</h4>
              <p className="project-section-text">
                Centralized digital management system covering billing, payments, reporting, and operations.
              </p>
            </div>
            <div className="project-section">
              <h4 className="project-section-title">Outcome</h4>
              <p className="project-section-text">
                Improved efficiency, transparency, and revenue tracking.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;

